module.exports = __webpack_public_path__ + "img/resistex.96d678e6.jpg";